import React, { useId } from "react";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";

const CustomTextField = ({
  name,
  control,
  label,
  required = false,
  maxLength,
  placeholder,
  type = "text",
  rules = {},
  InputProps,
  ...props
}) => {
  const id = useId();

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required, ...rules }}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          id={id}
          label={label}
          required={required}
          placeholder={placeholder}
          type={type}
          error={!!error}
          helperText={error ? error.message : props.helperText}
          inputProps={{ maxLength, ...props.inputProps }}
          fullWidth
          margin="dense"
          size="small"
          InputProps={{
            ...InputProps,
            sx: {
              ...(InputProps?.sx || {}),
              '&.Mui-disabled': {
                opacity: 1,
              },
            },
          }}
          sx={{
            '& .MuiFormLabel-asterisk': {
              color: 'red',
            },
            '& .MuiInputBase-input.Mui-disabled': {
              WebkitTextFillColor: '#000', // visible text
              opacity: 1,
            },
            '& .MuiOutlinedInput-root.Mui-disabled fieldset': {
              borderColor: '#d0d0d0',
            },
          }}
          {...props}
        />
      )}
    />
  );
};


export default CustomTextField;
